<template>
  <naj-confirmation
    :show-modal="showModal"
    :max-width="500"
    :is-persistent="persistent"
    :show-close-btn="closeBtn"
    :no-header="true"
    :duration="duration"
    @cancel="$emit('onCancelModal')"
  >
    <template slot="message-content">
      <div class="title-container">
        <h4 class="attendanceRegister-title-condition">
          {{ otpTitle }}
        </h4>
      </div>
      <div
        v-if="otpSendToSocialId"
        class="title-container"
      >
        <h5 class="attendanceRegister-title-condition direction">
          {{ content }} <br>
          {{ hideLastNumbers(otpSendToSocialId) }}
        </h5>
      </div>
      <div class="otp-container">
        <input
          v-for="(digit, index) in otpValue"
          :key="index"
          :ref="`otpInput${index}`"
          v-model="otpValue[index]"
          :class="['otp-input', {'invalid-otp': errorMessage != ''}] "
          maxlength="1"
          type="text"
          @input="handleInput(index)"
          @keydown="handleKeyDown(index, $event)"
        >
      </div>
      <div class="otp-error-message">
        <h6>{{ errorMessage }}</h6>
      </div>
      <div
        v-if="duration"
        style="text-align: center;"
      >
        <div class="remaining-time">
          <h6>
            {{ local.otp.remainingTime }}
          </h6>
          <h6 class="duration">
            {{ minutes }}:{{ seconds }}
          </h6>
        </div>
      </div>
      <div
        v-if="duration == 0"
        class="title-container"
      >
        <h6>
          {{ local.otp.didNotReceiveOTP }} <span
            class="resend-otp"
            @click="sendOTPCode"
          >{{ local.otp.resendOTP }}</span>
        </h6>
      </div>
      <div class="underline" />
      <div class="validate-otp">
        <naj-button @click="validateOTPCode()">
          {{ local.otp.check }}
        </naj-button>
      </div>
      <slot name="message-content" />
    </template>
  </naj-confirmation>
</template>

<script>
export default {
  name: 'NajOtpInput',
  components: {},
  props: {
    type: {
      type: String,
      default: 'alert',
    },
    showModal: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    closeBtn: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    okActionName: {
      type: String,
      default: null,
    },
    subTitle: {
      type: String,
      default: null,
    },
    otpTitle: {
      type: String,
      required: false,
      default: null,
    },
    content: {
      type: String,
      required: false,
      default: null,
    },
    otpSendToSocialId: {
      type: String,
      required: false,
      default: null,
    },
    duration: {
      type: Number,
      required: false,
      default: null,
    },
    regenerateOTPMethodName: {
      type: String,
      required: false,
      default: null,
    },
    errorMessage: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      otpValue: Array(4).fill(''),
      minutes: null,
      seconds: null,
    };
  },
  watch: {
    otpValue(newValue) {
      this.$emit('input', newValue);
    },
  },
  methods: {
    handleInput(index) {
      this.$emit('childReturnErrorMessageValue', '');
      // ensure only numeric values are allowed
      this.otpValue[index] = this.otpValue[index].replace(/\D/g, '');
      // move focus to the next input if the current input is filled
      const lastDigitIndex = this.otpValue.length - 1;
      if (this.otpValue[index].length === 1 && index < lastDigitIndex && this.$refs[`otpInput${index + 1}`]) {
        this.$refs[`otpInput${index + 1}`][0].focus();
      }
    },
    handleKeyDown(index, event) {
      this.$emit('childReturnErrorMessageValue', '');
      // detect if the user pressed a digit or backspace
      if (/\d/.test(this.otpValue[index]) && index < this.otpValue.length - 1 && this.$refs[`otpInput${index + 1}`]) {
        this.$refs[`otpInput${index + 1}`][0].focus();
      } else if (index > 0 && this.otpValue[index] === '' && event.keyCode === 8) {
        // move focus to the previous input on backspace if the current input is empty
        this.$refs[`otpInput${index - 1}`][0].focus();
      }
    },
    countDownTimer(duration) {
      if (!this.showModal) {
        duration = null;
        this.minutes = null;
        this.seconds = null;
      }
      else {
        if (duration > 0) {
          setTimeout(() => {
            duration -= 1;
            this.minutes = Math.floor(duration / 60);
            this.minutes = this.minutes < 10 ? `0${this.minutes}` : this.minutes;
            this.seconds = duration % 60;
            this.countDownTimer(duration);
          }, 1000);
        }
      }
      this.$emit('childReturnDurationValue', duration);
    },
    clearInputs() {
      this.otpValue = Array(4).fill('');
    },
    hideLastNumbers(otpSendToSocialId) {
      if (otpSendToSocialId && otpSendToSocialId.length > 9) {
        const hiddenId = otpSendToSocialId.slice(0, -6) + '******';
        return hiddenId;
      } else {
        return null;
      }
    },
    sendOTPCode() {
      this.$emit('resendOTPCode');
    },
    validateOTPCode() {
      this.$emit('validateOTP');
    },
  },
};
</script>

<style lang="scss" scoped>
.title-container {
  text-align: center;
  padding-bottom: 30px;
}
.center-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
}

.remaining-time {
  font-size: 15px;
  text-align: center;
  display: -webkit-inline-box;
}
.duration {
  color: red;
  margin-right: 5px;
}
.center-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.otp-container {
  text-align: center;
  padding-bottom: 10px;
  direction: ltr;
}
.otp-input {
  width: 3em;
  height: 3em;
  text-align: center;
  font-size: 1.5em;
  margin: 0.5em;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 1px 1px #ccc;
}
.invalid-otp {
  border: solid 1px red;
  text-align: center;
}
.otp-error-message {
  color: red;
  text-align: center;
  padding: 10px;
}
.direction {
  direction: ltr;
}
.resend-otp {
  cursor: pointer;
  color: var(--app-primary-color);
  font-weight: bold;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 15px;
}
.underline {
  width: 100%;
  height: 1px;
  background-color: #dbdbdb;
  margin-top: 30px;
}
.validate-otp {
  cursor: pointer;
  color: var(--app-primary-color);
  text-align: center;
  font-size: 15px;
  padding-top: 20px;
}
.otp-error-message {
  color: red;
  text-align: center;
  padding: 10px;
}
</style>
